import Image from 'next/image';
import ReactConfig from '@stereoagency/ui/lib/ReactConfig';
import { twMerge } from '@stereoagency/tailwind-config';

export default function registerImageComponent() {
  ReactConfig.ImageComponent = ({
    alt,
    src,
    sizes,
    width,
    height,
    className
  }) => (
    <Image
      alt={alt ?? ''}
      src={src}
      sizes={sizes}
      width={width}
      height={height}
      className={twMerge('w-full', className)}
    />
  );
}
